import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const roleAliases: Record<string, string> = {
      admin: 'Manager',
      manager: 'Manager',
      user: 'Usuario',
      usuario: 'Usuario',
      'usuario avanzado': 'Usuario Avanzado',
      usuario_avanzado: 'Usuario Avanzado',
      advanceduser: 'Usuario Avanzado',
      'advanced user': 'Usuario Avanzado',
      operator: 'Operador',
      operador: 'Operador',
      commercial: 'Comercial',
      comercial: 'Comercial',
      'usuario transformación': 'Usuario Transformación',
      usuario_transformacion: 'Usuario Transformación',
      transformacion: 'Usuario Transformación',
      'usuario avanzado transformación': 'Usuario Avanzado Transformación',
      usuario_avanzado_transformacion: 'Usuario Avanzado Transformación',
      advanced_transformacion: 'Usuario Avanzado Transformación',
    };
    const normalizeRole = (role: string): string => roleAliases[String(role || '').trim().toLowerCase()] || String(role || '').trim();
    const requiredRoles = (route.data['roles'] || []).map((role: string) => normalizeRole(role));

    if (!this.authService.hasValidSessionSnapshot()) {
      this.router.navigate(['/auth/login']);
      return of(false);
    }

    const hasAccess = (roles: string[]): boolean => {
      if (roles.includes('Manager')) {
        return true;
      }
      if (requiredRoles.length === 0) {
        return true;
      }
      return roles.some((role) => requiredRoles.includes(role));
    };

    const localRoles = this.authService.getEffectiveRoles();
    if (hasAccess(localRoles)) {
      return of(true);
    }

    return this.authService.verifyStoredSession().pipe(
      map((payload: any) => {
        if (!payload?.error) {
          this.authService.applyVerifiedSession(payload);
          const verifiedRoles = this.authService.getEffectiveRoles();
          if (hasAccess(verifiedRoles)) {
            return true;
          }
        }

        this.router.navigate(['/pages/camaras/403']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/auth/login']);
        return of(false);
      }),
    );
  }
}
